export default __webpack_public_path__ + "static/Hero_10_Culture-ef40aa4cc157bb29daf4663282b78048.jpg";